/**
 * "TEMETTÜ HARİÇ" (kullanıcı kararı 19.10.2026): kuralı temettüyü yok sayan
 * sanal hesabın getiri başlıklarının altında küçük gri etiket; balonda sebebi.
 * Uyarı ikonu YOK — seçilen davranış bir anormallik değil.
 */

import type { SanalHesapTanimi } from "@parafon/contracts/local-api";
import { Aciklama } from "../ui/Aciklama";
import { M } from "../dil";

export const TEMETTU_HARIC_BALON = M.rapor.temettuHaric.balon;

export function temettuHaricMi(t: Pick<SanalHesapTanimi, "temettu"> | null | undefined): boolean {
  return t?.temettu === "yokSay";
}

export function TemettuHaric() {
  return (
    <Aciklama label={M.rapor.temettuHaric.neden} icerik={<p>{TEMETTU_HARIC_BALON}</p>}>
      <span className="block text-[10px] font-normal normal-case tracking-normal text-faint">{M.rapor.temettuHaric.etiket}</span>
    </Aciklama>
  );
}
